<script lang="ts">
    import SvelteTypedJs from 'svelte-typed-js';
    import {scrollIntoView} from '../Common.svelte';
</script>

<div id="home" class="relative pt-[120px] lg:pt-[150px] pb-[110px] bg-white">
    <div class="container">
        <div class="flex flex-wrap -mx-4">
            <div class="w-full lg:w-5/12 px-4">
                <div class="hero-content">
                    <h1
                            class="
                          text-dark
                          font-bold
                          text-4xl
                          sm:text-[42px]
                          lg:text-[40px]
                          xl:text-[42px]
                          leading-snug
                          mb-3
                        "
                    >
                        Queue Management <br/>
                        as a Service for <br/>
                        <SvelteTypedJs
                                strings={[
                                    'laundromats.',
                                    'barbershops.',
                                    'restaurants.',
                                    'banks.',
                                    'salons.',
                                    'SMEs.',
                                ]}
                                typeSpeed="8"
                                backSpeed="8"
                                startDelay="400"
                                backDelay="1000"
                                showCursor="true"
                                loop="true"
                        >
                            <span class="typing text-primary"></span>
                        </SvelteTypedJs>
                    </h1>
                    <p class="text-base mb-8 text-body-color max-w-[480px]">
                        Eliminate needlessly long lines by moving your lines to the cloud.
                    </p>
                    <h3
                            class="
                          text-dark
                          font-bold
                          text-4xl
                          sm:text-[32px]
                          lg:text-[30px]
                          xl:text-[32px]
                          leading-snug
                          mb-3
                        "
                    >
                        Coming Soon!
                    </h3>
                    <p class="text-base mb-8 text-body-color max-w-[480px]">
                        NoLines is still under active development, we'll let you know once we're ready to help you.
                    </p>
                    <ul class="flex flex-wrap items-center">
                        <li>
                            <a
                                    on:click|preventDefault={scrollIntoView}
                                    href="#newsletter"
                                    class="
                                      py-4
                                      px-6
                                      sm:px-10
                                      lg:px-8
                                      xl:px-10
                                      inline-flex
                                      items-center
                                      justify-center
                                      text-center text-white text-base
                                      bg-primary
                                      hover:bg-opacity-90
                                      font-normal
                                      rounded-lg
                                    "
                            >
                                Let me know!
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="hidden lg:block lg:w-1/12 px-4"></div>
            <div class="w-full lg:w-6/12 px-4">
                <div class="lg:text-right lg:ml-auto">
                    <div class="relative inline-block z-10 pt-11 lg:pt-0">
                        <img
                                src="images/hero.avif"
                                alt="hero"
                                class="max-w-full lg:ml-auto"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>